export const patrycjaSawicka = {
    'mydrId': 'patrycjasawicka-czarniak',
    'firstName': 'Patrycja',
    'lastName': 'Sawicka-Czarniak',
    'profession': 'Lekarz rezydent psychiatrii',
    'avatar': 'patrycja-sawicka.webp',
    'slug': 'psychiatra-patrycja-sawicka-czarniak',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'adult']
    ]
}